import api from '../index';

type GigDeliverable = {
  kind: string;
  requiredCount: number;
  requiredSubKindCount?: number | null;
};

type CreateBrandNegotiationParams = {
  costInCents: number;
  paidGigId: string;
  gigDeliverables: GigDeliverable[];
  contentAgreementTimePeriodInMonths?: number | null;
};

const brandNegotiationsUpdaters = {
  create: async (params: CreateBrandNegotiationParams) => {
    return api.post('brand_negotiations', {
      costInCents: params.costInCents,
      paidGigId: params.paidGigId,
      gigDeliverables: params.gigDeliverables,
      contentAgreementTimePeriodInMonths:
        params.contentAgreementTimePeriodInMonths,
    });
  },
  withdraw: async ({id}: {id: string}) => {
    return api.put(`brand_negotiations/${id}/withdraw`, null);
  },
};

export default brandNegotiationsUpdaters;
